import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { makeStyles, Select } from "@material-ui/core";
import get from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import { Edit, Delete, PersonAdd } from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Pagination from "components/Common/pagination.jsx";
import { useNavigate } from "react-router-dom";
import { delete_ } from "lib/requests";
import { LoadingMgs } from "components/Common/toastify";
import { SuccessMessage } from "components/Common/toastify";
import { post } from "lib/requests";
import { useSelector } from "react-redux";

const useStyles2 = makeStyles(headersStyle);
const useStyles3 = makeStyles(basicsStyle);
const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const perPageOptions = [10, 20, 30, 50, 100];

const UsersList = () => {
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const userDetails = useSelector((state) => state.user);
	const [loading, setLoading] = useState(false);
	const classes = useStyles();
	const [perPage, setPerPage] = useState(10);
	const [users, setUsers] = useState([]);
	const [page, setPage] = useState(1);
	const classes3 = useStyles3();
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		getUsers();
		return function cleanup() {};
	}, [perPage, page]);

	const extractData = (data) => {
		if (!data) return [];
		const userList = data?.map((user) => {
			return [
				prepareTitle(user),
				inputCheckBox(user.isAdmin),
				inputCheckBox(user.iscreator),
				inputCheckBox(user.viewaccounts),
				inputCheckBox(user.readonly),
				user.phone,
				user.email,
				ADD_BTN(user),
			];
		});
		return userList;
	};

	const inputCheckBox = (value) => {
		return (
			<input
				type="checkbox"
				className={classNames(
					classesCSStyles?.inputQty,
					classesCSStyles?.inputQtyCheckbox
				)}
				checked={value}
				disabled={true}
			/>
		);
	};

	const prepareTitle = (product) => {
		return (
			<div className={classesCSStyles?.labelAc}>
				<h4>{product.fname}</h4>
			</div>
		);
	};

	const ADD_BTN = (user) => {
		return (
			userDetails?.canaddeditdelete && (
				<div>
					<Button
						round
						justIcon
						size="sm"
						color={"info"}
						onClick={() => {
							navigate(`/user/${user.UserID}/edit`);
						}}>
						<Edit className={classesCSStyles?.editIcon} />
					</Button>
					&nbsp; &nbsp;
					<Button
						round
						justIcon
						size="sm"
						color={"white"}
						onClick={() => {
							resetQR(user.UserID);
						}}>
						<i className={classNames("fas fa-qrcode", classesCSStyles?.qrBtn)} />
					</Button>
					&nbsp; &nbsp;
					<Button
						round
						justIcon
						size="sm"
						color={"danger"}
						onClick={() => {
							deleteUser(user.UserID);
						}}>
						<Delete className={classesCSStyles?.editIcon} />
					</Button>
				</div>
			)
		);
	};

	const getUsers = async () => {
		setLoading(true);
		try {
			await get(`/api/users?perpage=${perPage}&page=${page}`, true)
				.then((res) => {
					if (res.data.success) {
						setUsers(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Users", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Users", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Users", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const handlePerPage = (event) => {
		setPerPage(event.target.value);
	};

	const deleteUser = async (userId) => {
		setLoading(true);
		LoadingMgs("User Delete", "processing...");
		try {
			await delete_(`/api/deleteuser/${userId}`, true)
				.then((res) => {
					if (res.data.success) {
						getUsers();
						SuccessMessage("User Delete", "User deleted successfully!!");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("User Delete", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("User Delete", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("User Delete", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	async function resetQR(userId) {
		setLoading(true);
		LoadingMgs("Reset QR", "processing...");

		try {
			await post(`/api/user/resetqr/${userId}`, {}, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Reset QR", "QR code reset successfully!!");
						navigate("/users");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						ErrorMessage("Reset QR", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Reset QR", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Reset QR", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	return (
		<div className={classNames(classesCSStyles.mx5, classesCSStyles.my10)}>
			<br />
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader color="info">
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>Users</h4>
						</GridItem>
						<GridItem
							xs={12}
							sm={6}
							md={6}
							className={classNames(classes2.mlAuto, classesCSStyles?.rightAlign)}>
							{userDetails?.canaddeditdelete && (
								<button
									className={classNames(classesCSStyles?.buttonPrimary)}
									onClick={() => {
										navigate("/add-user");
									}}>
									<PersonAdd className={classesCSStyles?.buttonIcon} />
								</button>
							)}
						</GridItem>
					</GridContainer>
				</CardHeader>
				<CardBody className={classNames(classesCSStyles.accountSection)}>
					<GridContainer className={classNames(classesCSStyles.marginAuto)}>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classesCSStyles.rightSideBorder,
								classesCSStyles?.mB,
								loading ? classesCSStyles.loading : ""
							)}>
							<div className={classNames(classes2.mlAuto, classesCSStyles?.my10)}>
								<Table
									striped
									tableHead={[
										"Name",
										"Administrator",
										"License Admin",
										"Accounts",
										"Read Only",
										"Telephone",
										"Login/Email",
										"Action",
									]}
									tableData={extractData(users?.users)}
									customCellClasses={[
										classes.textLeft,
										classes.textLeft,
										classes.textLeft,
										classes.textLeft,
										classes.textLeft,
									]}
									customClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8]}
									customHeadCellClasses={[
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
									]}
									customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8]}
								/>
							</div>
							<div
								className={classNames(
									classesCSStyles?.moveRight,
									"flex",
									classesCSStyles?.paginationSection,
									classesCSStyles?.justifyInBetween
								)}>
								<Select
									MenuProps={{
										className: classes3.selectMenu,
									}}
									classes={{
										select: classes3.select,
									}}
									value={perPage}
									onChange={handlePerPage}
									inputProps={{}}>
									{perPageOptions.map((item, index) => (
										<MenuItem
											key={index}
											classes={{
												root: classes3.selectMenuItem,
												selected: classes3.selectMenuItemSelected,
											}}
											value={item}>
											{item}
										</MenuItem>
									))}
								</Select>
								{users?.total > 0 && (
									<Pagination
										onPageChange={(page) => setPage(page)}
										totalCount={users?.total}
										currentPage={page}
										pageSize={perPage}
									/>
								)}
							</div>
							{loading && (
								<Loading
									width={30}
									height={30}
									className={classesCSStyles.absoluteLoading}
								/>
							)}

							{!loading && (users.length === 0 || users?.length === 0) && (
								<div className={classNames(classesCSStyles?.my10)}>
									No users Available. Please try again later.
								</div>
							)}
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
		</div>
	);
};

export default UsersList;
